import React, {useCallback, useMemo} from 'react';
import UpArrow from "../../../common/TagWithArrow/UpArrow";
import styled from "styled-components";
import {patchHistoryTime} from "../../../../function";
import {useSelector} from "react-redux";
import DownArrow from "../../../common/TagWithArrow/DownArrow";
import {useTranslation} from "react-i18next";
import {FlexBox} from "../../../ui/styled";

const VersionAndStatusWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;
const VersionWrapper = styled.div`
  width: 180px;
  padding: 6px 0;
  display: flex;
  flex-direction: column;
  position: relative;
`;

const VersionText = styled.span`
  font-size: 28px;
  font-weight: bold;
`;

const HeightBar = styled.div`
  position: absolute;
  left: -14px;
  top: 6px;
  width: 4px;
  height: 52px;
  background: ${props => props.theme.color.green_100};
`;

const DateText = styled.span`
  width: 23ch;
  margin-top: 6px;
  font-size: 10px;
  opacity: 0.8;
`;

const BuffAndNerfWrapper = styled.div`
  margin-left: 10px;
  padding: 4px 5px;
  border-radius: 4px;
  background-color: ${props => props.theme.color.white_200};
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const BuffNerfText = styled.span`
  margin-left: 4px;
  font-size: 12px;
`;

const InfoWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const HistoryContentDayInfo = ({version, date = Date.now(), correction, hotfix}) => {
    const {t} = useTranslation();
    const currentLang = useSelector((state) => state.translation.lang);
    const dateRender = useMemo(() => {
        const newDate = new Date(Number(date * 1000));
        const leftDate = patchHistoryTime(Number(date), currentLang)
        return `${newDate.getFullYear()}.${newDate.getMonth() + 1 > 9 ? newDate.getMonth() + 1 : '0' + (newDate.getMonth() + 1)}.${newDate.getDate() > 9 ? newDate.getDate() : "0" + (newDate.getDate())} (${leftDate})`
    }, [date, currentLang]);

    const BuffOrNerf = useCallback((status) => {
        switch (status) {
            case 'buff' : {
                return (
                    <BuffAndNerfWrapper>
                        <UpArrow size={6}/>
                        <BuffNerfText>{t('championsHistory.buff')}</BuffNerfText>
                    </BuffAndNerfWrapper>
                )
            }
            case 'nerf' : {
                return (
                    <BuffAndNerfWrapper>
                        <DownArrow size={6}/>
                        <BuffNerfText>{t('championsHistory.nerf')}</BuffNerfText>
                    </BuffAndNerfWrapper>
                )
            }
            case 'fix': {
                return (
                    <BuffAndNerfWrapper>
                        <img src={'./images/icon_adj.svg'} width={12} height={12} alt={''}/>
                        <BuffNerfText>{t('championsHistory.adj')}</BuffNerfText>
                    </BuffAndNerfWrapper>
                )
            }
            case 'hot_fix': {
                return (
                    <BuffAndNerfWrapper>
                        <img src={'./images/icon_hotfix.svg'} width={12} height={12} alt={''}/>
                        <BuffNerfText>{t('championsHistory.hotfix')}</BuffNerfText>
                    </BuffAndNerfWrapper>
                )
            }
        }
    }, [])

    return (
        <VersionWrapper>
            <VersionAndStatusWrapper>
                <VersionWrapper>
                    <FlexBox alignItems={'center'}>
                        <VersionText>{version}</VersionText>
                        {BuffOrNerf(correction)}
                    </FlexBox>
                    <DateText>{dateRender}</DateText>
                    <HeightBar/>
                </VersionWrapper>
            </VersionAndStatusWrapper>
        </VersionWrapper>
    );
};

export default HistoryContentDayInfo;
